import React from "react";
import { motion } from "framer-motion";
import CheckoutButton from "./CheckoutButton";

export default function FinalCta() {
  return (
    <section
      data-testid="final-cta-section"
      id="offre"
      className="relative py-28 md:py-44 px-6 md:px-10 overflow-hidden"
    >
      {/* Ambient gold glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[80%] bg-radial-gold opacity-30" />
        <div
          className="absolute inset-0 opacity-40"
          style={{
            background:
              "radial-gradient(ellipse at center, rgba(197,160,89,0.18) 0%, transparent 60%)",
          }}
        />
      </div>

      <div className="relative max-w-5xl mx-auto text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-xs tracking-[0.4em] uppercase text-gold mb-10"
        >
          Dernière chose
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
          className="font-display uppercase text-4xl md:text-6xl lg:text-7xl leading-[0.95] tracking-[-0.02em] mb-10"
        >
          Ta place n'attend pas que tu sois{" "}
          <span className="font-serif italic font-light text-gold normal-case lowercase">
            parfait
          </span>
          .
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.25 }}
          className="font-serif italic text-xl md:text-3xl text-ink-100/90 max-w-2xl mx-auto mb-16 lowercase"
        >
          elle attend peut-être seulement ton oui.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="flex flex-col items-center gap-6"
        >
          <CheckoutButton testId="final-cta-button" showArrow>
            J'y vais
          </CheckoutButton>

          <div className="flex items-baseline gap-3">
            <span className="font-display text-4xl md:text-5xl text-ink-50">
              77 €
            </span>
            <span className="font-serif italic text-ink-400 text-sm ml-2">
              · accès immédiat
            </span>
          </div>

          <p className="text-[11px] tracking-[0.3em] uppercase text-ink-400/80 mt-2">
            Paiement sécurisé · accès à vie
          </p>
        </motion.div>
      </div>
    </section>
  );
}
